// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"ebfd5a96","197":"52f61192","815":"ce0a2394","860":"42ebc98e"}[chunkId] + ".chunk.js";
};